module.exports = __webpack_public_path__ + "img/icon2.c2d8b4e9.png";